export { default as PlusSmSolidIcon } from './PlusSmSolidIcon';
